"use client"

import { cn } from "@/lib/utils"

/**
 * Secondary "Installments" badge rendered alongside the invoice
 * ``StatusBadge`` when the invoice carries an installment plan. The
 * status itself stays the existing status badge; this badge only flags
 * that the invoice is billed as an installment plan (sibling of
 * ``DepositBadge``). Purple ``bg-primary/10 text-primary`` so it reads
 * distinctly from the blue deposit badge at a glance.
 */
export function InstallmentBadge({
  className,
  testId = "installment-badge",
}: {
  className?: string
  testId?: string
}) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded text-caption font-medium bg-primary/10 text-primary",
        className,
      )}
    >
      Installments
    </span>
  )
}
